import { useWeb3Modal } from "@web3modal/wagmi/react";
import { useEffect, useRef, useState } from "react";
import { useAccount } from "wagmi";

import { useMemberInfo } from "@/contexts/contest-member-info/hooks";
import { StorageKey, useLocalStorage } from "@/hooks/use-local-storage";
import { request } from "@/util/request";
import { trackConnectWalletClick, trackJoinRaffleClick } from "@/util/tracking";

const addContestMember = async (
  userAddress: string,
  referral: string | null,
) => {
  return request("contest/member", {
    method: "POST",
    body: JSON.stringify({
      userAddress,
      contestId: 1,
      referral,
    }),
  });
};

export const useRegistration = () => {
  const { address } = useAccount();
  const web3Modal = useWeb3Modal();
  const { value } = useLocalStorage<string>(StorageKey.Referral);
  const { refetch, refCode, loaded: refCodeLoaded } = useMemberInfo();

  const [isRegisterClicked, setIsRegisterClicked] = useState(false);

  const refetchRef = useRef<(() => void) | undefined>(refetch);
  useEffect(() => {
    refetchRef.current = refetch;
  }, [refetch]);

  const needRegister =
    isRegisterClicked && address && refCodeLoaded && !refCode;

  useEffect(() => {
    if (needRegister) {
      const register = async () => {
        try {
          await addContestMember(address, value);
          refetchRef.current?.();
        } finally {
          setIsRegisterClicked(false);
        }
      };
      register();
    }
  }, [address, needRegister, value]);

  const registration = () => {
    setIsRegisterClicked(true);
    trackJoinRaffleClick();
    if (!address) {
      trackConnectWalletClick();
      web3Modal.open();
    }
  };

  return { registration };
};
